/*
 * Login "Continuar com Google" (1 clique) — cliente do backend dormante.
 *
 * O backend só ativa os endpoints /api/auth/google/* quando o dono
 * configura os secrets GOOGLE_CLIENT_ID/GOOGLE_CLIENT_SECRET no worker.
 * Sem secrets: /status responde {configured:false} e o chip NÃO aparece
 * na UI (falha fechada — qualquer erro de rede também esconde o chip).
 */
import { API_BASE } from './client';

/** Cache module-level — evita 2 fetches quando o chip monta em 2 lugares */
let statusPromise: Promise<boolean> | null = null;

/**
 * true se o login Google está configurado no backend.
 * Falha fechada: erro de rede / resposta inesperada → false (chip oculto).
 */
export function fetchGoogleOAuthConfigured(): Promise<boolean> {
  if (statusPromise === null) {
    statusPromise = (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/auth/google/status`);
        if (!res.ok) return false;
        const body = (await res.json()) as { configured?: unknown };
        return body.configured === true;
      } catch {
        return false;
      }
    })();
  }
  return statusPromise;
}

/**
 * URL do redirect que inicia o fluxo OAuth no backend.
 * anonId (trial v2) permite migrar o trial anônimo server-side no callback —
 * mesmo mecanismo do verify-code do magic link.
 */
export function buildGoogleStartUrl(
  anonId?: string | null,
  locale?: string,
): string {
  const params = new URLSearchParams();
  if (anonId) params.set('anonId', anonId);
  if (locale) params.set('locale', locale);
  const qs = params.toString();
  return `${API_BASE}/api/auth/google/start${qs ? `?${qs}` : ''}`;
}
